export const ADD_PRODUCTS = 'ADD_PRODUCTS';

const products = (state = [], action) => {
  switch (action.type) {
    case 'ADD_PRODUCTS':
      return action.data;
    default:
      return state;
  }
};

export default products;
